import { useCallback, useEffect, useState } from 'react';

const Header = () => {
    const [activeSection, setActiveSection] = useState('');

    useEffect(() => {
        const sections = document.querySelectorAll('section');

        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        setActiveSection(entry.target.id);
                    }
                });
            },
            { threshold: 0.25 }
        );

        sections.forEach(section => observer.observe(section));

        return () => observer.disconnect();
    }, []);

    const className = useCallback((href: string) => `nav-link me-4 ${activeSection === href ? 'active' : ''}`, [activeSection]);

    const navbar = [
        { id: 'chiSiamo', description: 'Chi siamo' },
        { id: 'servizi', description: 'Servizi' },
        { id: 'formazione', description: 'Formazione' },
        { id: 'gallery', description: 'Galleria' },
        { id: 'contact', description: 'Contatti' },
    ];

    return (
        <header id='header' className='header fixed-top'>
            <div className='container-fluid container-xl position-relative'>
                <nav className='navbar navbar-expand-lg'>
                    <div className='container-fluid'>
                        <a className='logo navbar-brand' href='/'>
                            Marrone
                        </a>
                        <button
                            className='navbar-toggler'
                            type='button'
                            data-bs-toggle='collapse'
                            data-bs-target='#navbarToggler'
                            aria-controls='navbarToggler'
                            aria-expanded='false'
                            aria-label='Toggle navigation'
                        >
                            <i className='bi bi-list fs-2'></i>
                        </button>

                        <div className='collapse navbar-collapse mt-3 mt-lg-0' id='navbarToggler'>
                            <ul className='navbar-nav ms-auto mb-2 mb-lg-0'>
                                {navbar.map(item => {
                                    return (
                                        <li>
                                            <a className={className(item.id)} href={`#${item.id}`}>
                                                {item.description}
                                            </a>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    );
};
export default Header;
